<!-- <div class="tw-flex tw-flex-col tw-gap-1 tw-mt-5">
  <div
    class="tw-font-bold tw-text-lg tw-leading-6 tablet:tw-text-2xl tw-text-dark-grey"
  >
    {{ heading }}
  </div>
  <div
    class="tw-font-normal tw-text-xs tw-leading-[18px] tablet:tw-text-base tablet:tw-leading-5 tw-text-mercury-600"
  >
    {{ subHeading }}
  </div>
</div>
<div class="tw-bg-white tw-border-b tw-border-solid">
  <sml-tabs
    [tabs]="sections"
    activeTab="photoGallery"
    [switchTab]="switchTab"
    (activeTabChange)="activeTabChange($event)"
  ></sml-tabs>
</div>
<div class="tw-mt-5">
  <sml-media-uploader
    [allowedFileTypes]="
      activeTab === tabSectionStrings.PHOTO_GALLERY
        ? allowedFileTypes
        : allowedDocumentsTypes
    "
    [mediaFiles]="galleryFilesFinal"
    [docFiles]="documentFilesFinal"
    (documentFilesLength)="documentFilesLength($event)"
    (galleryFilesLength)="galleryFilesLength($event)"
    (isFileUploaded)="onFilesChanged($event)"
    (allowTabSwitch)="allowTabSwitch($event)"
  ></sml-media-uploader>
</div> -->

<div class="tw-bg-white tw-rounded-2xl">

  <div class="tw-mt-5 tw-flex tw-flex-col tw-gap-5">
    <sml-media-uploader
      [fromCampaignDesign]="true"
      [allowedFileTypes]="allowedFileTypes"
      [mediaFiles]="galleryFilesFinal"
      (documentFilesLength)="documentFilesLength($event)"
      (galleryFilesLength)="galleryFilesLength($event)"
      (isFileUploaded)="onFilesChanged($event)"
    ></sml-media-uploader>
    <button [smlButton]="'secondary'" type="button" [size]="'md'" [rounded]="'md'" class="!tw-max-w-[155px] !tw-px-0 !tw-z-0" (click)="isDocumentVisible = true" *ngIf="!isDocumentVisible">
      <div class="tw-flex tw-items-center tw-gap-1 tw-text-primary-700 tw-text-sm">
        <i-icon [name]="'clipboard-document-list'" class="!tw-w-[22px] !tw-h-[22px]"></i-icon>
        <div>
          Add Documents
        </div>
      </div>
    </button>
  </div>

  <div class="tw-pt-5 tw-border-dashed tw-border-t" *ngIf="this.isDocumentVisible"
  [ngClass]="{'tw-mt-5':this.isDocumentVisible}">
  <div class="tw-bg-[#F8F8F8] tw-p-2 tw-rounded-lg" >
    <div class="tw-flex tw-flex-col tw-gap-2">
      <div class="tw-flex tw-items-center tw-justify-between">

       <div>
        &nbsp;
       </div>
        <i-icon (click)="removeDocuments()" [name]="'trash'" class="!tw-w-[18px] !tw-h-[18px] tw-cursor-pointer"></i-icon>
      </div>
      <sml-media-uploader
      [isCampaignDocument]="true"
      [fromCampaignDesign]="true"
      [allowedFileTypes]="allowedDocumentsTypes"
      [docFiles]="documentFilesFinal"
      (documentFilesLength)="documentFilesLength($event)"
      (galleryFilesLength)="galleryFilesLength($event)"
      (isFileUploaded)="onFilesChanged($event)"
    ></sml-media-uploader>
    </div>
  </div>
</div>
</div>
